// extracted by mini-css-extract-plugin
export default {"container":"EgyptMap_container__RKU28","side_text":"EgyptMap_side_text__DGZHT","map_container":"EgyptMap_map_container__g4Jxm"};